module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-3"
  }, [_c('el-row', [(_vm.isCalendar) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "Pick a day"
    },
    model: {
      value: (_vm.value.date),
      callback: function($$v) {
        _vm.$set(_vm.value, "date", $$v)
      },
      expression: "value.date"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": _vm.removeMe
    }
  })], 1) : _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-top": "6px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Is open"
    },
    model: {
      value: (_vm.value.isOpen),
      callback: function($$v) {
        _vm.$set(_vm.value, "isOpen", $$v)
      },
      expression: "value.isOpen"
    }
  })], 1), _vm._v(" "), (_vm.value.isOpen) ? _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('time-array-picker', {
    model: {
      value: (_vm.value.hours),
      callback: function($$v) {
        _vm.$set(_vm.value, "hours", $$v)
      },
      expression: "value.hours"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-319ae8d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/DayHoursEditor.vue
// module id = 379
// module chunks = 4